import { JobDetail, JobSearchPublicCard, Planresult } from '@/types';
import { TrnOrderJobSearchPublicRequest } from '@/types/request';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { fetchJobSearchPublicList, fetchOrderInfo, fetchLocation, 
  fetchTrnClientById, fetchMarketName, fetchPassiveSmokingName, fetchResultAmonutName, 
  fetchRailwayNameByStation, fetchWorkType, fetchTrnShintyokuInfo, fetchCategPassiveSmokingMeasureName,
  fetchTrnClientMtById, fetchLocationMt
} from '../trnOrderEndpoint';
import { getMstNameByIdService } from './mstMyPageService';

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const getJobSearchPublicList = async (params: TrnOrderJobSearchPublicRequest) => {
  const trnOrderList: JobSearchPublicCard[] = [];

  const trnOrdersResult = await fetchJobSearchPublicList(params);

  if (trnOrdersResult.data.detail != null) {
    for (const info of trnOrdersResult.data.detail) {

      let jobDescription = info.jobDescription;
      // 最大100文字。101字目は「…」
      if (jobDescription && jobDescription.length > 100) {
        jobDescription = jobDescription.substring(0, 100) + '…';
      }

      trnOrderList.push({
        orderId: info.orderId,
        jobTitle: info.positionName,
        companyName: info.companyName,
        isLiked: info.isLiked,
        pickupLink: info.clientUrlPickupThisMonth,
        annualIncome: info.salary,
        isApply: info.isApply,
        isRefusal: info.isRefusal,
        workLocation: info.location,
        jobDescription: jobDescription,
        isBooster: info.isBooster,
      });
    }
  }

  const pageCursor = trnOrdersResult.data.pageCursor;
  const hasMore = trnOrdersResult.data.hasMore;

  return { trnOrderList, totalCount: trnOrdersResult.data.totalCount ?? 0, pageCursor, hasMore };
};


const getDutyPlaceNearStation = async (orderId: number, store: any) => {
    const locationState = await fetchLocation({
              orderIds: [orderId],
              locationNo: 'LIMIT_FIVE'
            });
    const location = locationState.data.detail;
    if(!location)
    {
      return '';
    }

    let dutyPlaceNearStation = '';

    for (let i = 0; i < location.length; i++) {
      const workLocation = location[i].workLocation;
      const prefName = await getMstNameByIdService(location[i].prefId, storeBase.MST_PREF, store);
      const cityName = await getMstNameByIdService(location[i].cityId, storeBase.MST_CITY, store);
      let addr = '';
      if(location[i].addr)
      {
        addr = location[i].addr;
      }

      // dutyPlace
      let dutyPlace = '';
      if (workLocation && workLocation !== '') {
        dutyPlace = `${workLocation}(${prefName}${cityName}${addr})`;
      } else {
        dutyPlace = `${prefName}${cityName}${addr}`;
      }

      // nearStation
      let nearStation = '';
      const stationId = location[i].stationId;
      if (stationId && stationId !== '') {
        let railwayName = '';
        const railwayState = await fetchRailwayNameByStation(stationId);
        if(railwayState.data.detail)
        {
          railwayName = railwayState.data.detail;
        }
        const railwayNameCnt = railwayName.split('／').length;
        if (railwayNameCnt > 1) {
          railwayName = '各線';
        }
        const stationName = await getMstNameByIdService(stationId, storeBase.MST_STATION, store);

        const walkbusFlg = location[i].walkBusFlg;
        const walkbusTime = location[i].walkBusTime;

        if ((walkbusFlg && walkbusFlg !== '') || (walkbusTime && walkbusTime !== '')) {
          let walkBus = '駅より';
          if (walkbusFlg && walkbusFlg !== '') {
            walkBus += await getMstNameByIdService(walkbusFlg, storeBase.MST_WALK_BUS, store);
          }
          if (walkbusTime && walkbusTime !== '') {
            walkBus += walkbusTime + '分';
          }
          nearStation = railwayName + '　' + stationName + walkBus;
        } else {
          nearStation = railwayName + '　' + stationName + '駅';
        }
      }
      
      const tmpDn = dutyPlace + (nearStation ? ' --- ' : '') + nearStation;
      if (tmpDn && tmpDn !== '') {
        dutyPlaceNearStation += tmpDn + '<br/>';
      }
    }

    return dutyPlaceNearStation;
};

 const getWorkLocation = async(trnorder: any, trnclient: any, store: any) => {

    let dutyPlaceNearStation = await getDutyPlaceNearStation(trnorder.orderId, store);
    const wkAreaMemo = trnorder.wkareamemo;
    if (wkAreaMemo && wkAreaMemo !== '') {
      dutyPlaceNearStation += wkAreaMemo + '<br/>';
    }

    const remoteWorkClient = trnclient.remoteWorkId;
    const remoteWorkOrder = trnorder.remoteWorkId;
    let workPlaceAfterEmploy = '';
    const enableRemoteWork = [1, 2, 3];
    const locationUpdRangeOrigin = trnorder.locationUpdRange;

    if (
      enableRemoteWork.includes(remoteWorkOrder) ||
      (remoteWorkOrder === 0 && enableRemoteWork.includes(remoteWorkClient))
    ) {
      workPlaceAfterEmploy = '雇い入れ直後：勤務地に記載の場所（リモートワークを行う場所を含む）<br/>';
    } else {
      workPlaceAfterEmploy = '雇い入れ直後：勤務地に記載の場所<br/>';
    }

    let locationUpdRange = locationUpdRangeOrigin;
    if (!locationUpdRange || locationUpdRange === '') {
      if (trnorder.transfer_flg === '4') {
        locationUpdRange = '変更なし（詳細は面接時にご確認ください）';
      } else {
        locationUpdRange = '会社の定める事業所（詳細は面接時にご確認ください）';
      }
    } else {
      locationUpdRange += ' （詳細は面接時にご確認ください）';
    }
    locationUpdRange = '変更の範囲：' + locationUpdRange;

    return dutyPlaceNearStation + workPlaceAfterEmploy + locationUpdRange;
  };

  const getWorkLocationMt = async (orderId: string) => {
      const locationState = await fetchLocationMt({
                orderIds: [orderId],
                locationNo: 'LIMIT_FIVE'
              });
      const location = locationState.data.detail;
      if(!location || !Array.isArray(location))
      {
        return '';
      }

      const addresses = [...location]
        .map(item => (item?.addr ?? '').trim())
        .filter(addr => addr !== '');

      return addresses.join('<br/>');
  };

const getResume = (client: any) =>
{
   let wcorplocation = '';
  let wfoundation = '';
  let wemployeecomposition = '';

  if (client.corplocation) {
    wcorplocation = client.corplocation + '<br/>';
  }

  if (client.foundation) {
    wfoundation = client.foundation + '<br/>';
  }

  if (client.employeeFlg == 1) {
    if (client.employeeNum !== null && client.employeeNum !== undefined && client.employeeNum !== '') {
      wemployeecomposition = 
        '■従業員構成:従業員数(' + 
        Number(client.employeeNum).toLocaleString('ja-JP') + 
        '人)　' +
        (client.employeecomposition || '');
    } else if (client.employeecomposition !== null && client.employeecomposition !== undefined && client.employeecomposition !== '') {
      wemployeecomposition = '■従業員構成:' + client.employeecomposition;
    }
  } else if (client.employeeFlg == 2) {
    if (client.employeeNum !== null && client.employeeNum !== undefined && client.employeeNum !== '') {
      wemployeecomposition = 
        '■従業員構成:社員数(' +
        Number(client.employeeNum).toLocaleString('ja-JP') +
        '人)　' +
        (client.employeecomposition || '');
    } else if (client.employeecomposition !== null && client.employeecomposition !== undefined && client.employeecomposition !== '') {
      wemployeecomposition = '■従業員構成:' + client.employeecomposition;
    }
  }

  return (wfoundation || '') + ( wcorplocation || '') + (wemployeecomposition || '');

};

const getPlanResult = async(client: any):Promise<Planresult> =>{
  const planresult:Planresult = {} as Planresult;
  let resultamount1name = '';
  let resultamount2name = '';
  if(client.resultamount1Id)
  {
    const resultAmonutNameStrte = await fetchResultAmonutName(client.resultamount1Id);
    if(resultAmonutNameStrte.data.detail)
    {
      resultamount1name = resultAmonutNameStrte.data.detail;
    }
  }
  if(client.resultamount2Id)
  {
    const resultAmonutNameStrte = await fetchResultAmonutName(client.resultamount2Id);
    if(resultAmonutNameStrte.data.detail)
    {
      resultamount2name = resultAmonutNameStrte.data.detail;
    }
  }
  planresult.resultamount1_title = resultamount1name;
  planresult.resultamount2_title = resultamount2name;
  planresult.planresult_when = client.planresult;
  planresult.planresult_value1 = client.planresultamount1A;
  planresult.planresult_value2 = client.planresultamount1B;
  planresult.actualresult1_when = client.actualresult1;
  planresult.actualresult1_value1 = client.actualresultamount1A;
  planresult.actualresult1_value2 = client.actualresultamount1B;
  planresult.actualresult2_when = client.actualresult2;
  planresult.actualresult2_value1 = client.actualresultamount2A;
  planresult.actualresult2_value2 = client.actualresultamount2B;
  return planresult;
};

 const getPassiveSmokingForObject = async(object: any) => {
    const PASSIVESMOKING_OTHER = 3;
    const PASSIVESMOKINGMEASURES_ORTHER = 3002;
    let passiveSmokingName = '';
    let passiveSmokingMeasureName = '';
    let passiveSmokingMemo = '';
    let passiveSmokingSourceMemo = '';
    const outputArr = [];
    if (object.passivesmokingId && object.passivesmokingId !== PASSIVESMOKING_OTHER) {
      const passiveSmokingNameState = await fetchPassiveSmokingName(object.passivesmokingId);
      if(passiveSmokingNameState.data.detail)
      {
        passiveSmokingName = passiveSmokingNameState.data.detail;
      }
    }

    if (object.passivesmokingmeasuresId && object.passivesmokingmeasuresId !== PASSIVESMOKINGMEASURES_ORTHER) {
      const passiveSmokingMeasureNameState = await fetchCategPassiveSmokingMeasureName(object.passivesmokingmeasuresId);
      if(passiveSmokingMeasureNameState.data.detail)
      {
        passiveSmokingMeasureName = passiveSmokingMeasureNameState.data.detail;
      }
    }

    passiveSmokingMemo = object.passivesmokingmemo;

    if (passiveSmokingName && passiveSmokingMeasureName) {
      passiveSmokingName = '対策' + passiveSmokingName + '　　' + passiveSmokingMeasureName;
    } else {
      passiveSmokingName = (passiveSmokingName ? '対策' + passiveSmokingName : '') + (passiveSmokingMeasureName ? passiveSmokingMeasureName : '');
    }

    if (passiveSmokingName && !passiveSmokingMemo) {
      passiveSmokingSourceMemo = '　　（詳細は面接時にご確認ください）';
    }

    outputArr.push(passiveSmokingName + passiveSmokingSourceMemo);
    outputArr.push(passiveSmokingMemo ? passiveSmokingMemo + '　　（詳細は面接時にご確認ください）' : null);

    return outputArr.filter(Boolean).join('<br/>');
  };

  const getPassiveSmoking = async(trnorder:any, trnclient: any) =>
  {
    let passiveSmoking = '';
    if (trnorder.passivesmokingId > 0 || trnorder.passivesmokingmeasuresId > 0 || trnorder.passivesmokingmemo) {
			passiveSmoking = await getPassiveSmokingForObject(trnorder); 
      if (passiveSmoking) {
			  passiveSmoking = '【募集要項：勤務地】' + passiveSmoking;
			}
		}
    else
    {
      passiveSmoking = await getPassiveSmokingForObject(trnclient);
      if (passiveSmoking)
      {
          passiveSmoking = '【会社概要：所在地】' + passiveSmoking;
      }
      else {
          passiveSmoking = '詳細は労働条件通知書にて明示いたします。';
      }
    }
    return passiveSmoking;
  };

  const getHtmlLangueSkill = (languageSkill: string) =>
  {
      let skillsArray: string[] = [];
      if(languageSkill)
      {
        skillsArray = languageSkill.split('///');
        skillsArray = skillsArray.filter(skill => skill.trim() !== '');
        return skillsArray;

      }
      return skillsArray;
  };

  const getRemoteWork = async (trnorder: any, trnclient: any, store: any) =>
  {
      let remoteWorkName = '';
      let remoteWorkMemo = '';

      if (trnorder.remoteWorkId || trnorder.remoteWorkMemo) {
        if(trnorder.remoteWorkId)
        {            
          remoteWorkName = await getMstNameByIdService(trnorder.remoteWorkId, storeBase.MST_REMOTE_WORK_ORDER, store);
        }
        remoteWorkMemo = trnorder.remoteWorkMemo??'';
      } else {
        if(trnclient.remoteWorkId)
        {            
          remoteWorkName = await getMstNameByIdService(trnclient.remoteWorkId, storeBase.MST_REMOTE_WORK_ORDER, store);
        }
        remoteWorkMemo = trnclient.remoteWorkMemo??'';
      }
      if (!remoteWorkMemo) {
        return remoteWorkName;
      } else {
        return `${remoteWorkName}【${remoteWorkMemo}】`;
      }
  };

   const getSideBusiness = async (trnorder: any, trnclient: any, store: any) =>
   {
      let sideBusinessName = '';
      let sideBusinessMemo = '';
      if (trnorder.sideBusinessId || trnorder.sideBusinessMemo) {
        if(trnorder.sideBusinessId)
        {            
          sideBusinessName = await getMstNameByIdService(trnorder.sideBusinessId, storeBase.MST_SIDE_BUSINESS_ORDER, store);
        }
        sideBusinessMemo = trnorder.sideBusinessMemo??'';
      } else {
        if(trnclient.sideBusinessId)
        {            
          sideBusinessName = await getMstNameByIdService(trnclient.sideBusinessId, storeBase.MST_SIDE_BUSINESS_ORDER, store);
        }
        sideBusinessMemo = trnclient.sideBusinessMemo??'';
      }

      if (!sideBusinessMemo) {
        return sideBusinessName;
      } else {
        return `${sideBusinessName}【${sideBusinessMemo}】`;
      }
    };

const fetchOrderInfoByOrderId = async (orderId: string, isBrowsing = false, isNeedCheckValidate = false, isPublic = false, isBooster = false, store: any) : Promise<JobDetail> => {
  const detail: JobDetail = {} as JobDetail;
  const orderInfo = await fetchOrderInfo(orderId, isBrowsing, isNeedCheckValidate, isPublic, isBooster);
  if (orderInfo.data.detail) {
    detail.orderId = orderInfo.data.detail.orderId;
    detail.companyName = orderInfo.data.detail.clientName;
    detail.jobTitle = orderInfo.data.detail.positionname;
    detail.pickupLink = orderInfo.data.detail.clientUrlPickupThisMonth;
    detail.recruitClosed = orderInfo.data.detail.isOrderClose;
    // For Favorite
    detail.hasProgress = orderInfo.data.detail.hasProgress;
    detail.isLiked = orderInfo.data.detail.isLiked;
    // For Progress (Apply/Refusal/Pending)    
    detail.orderProgressType = orderInfo.data.detail.orderProgressType;
    
    let updateDate = orderInfo.data.detail.updateDate;
    if (updateDate && updateDate.includes(' ')) {
      updateDate = updateDate.split(' ')[0];
    }    
    detail.updateDate = updateDate;
    const minannualincm = orderInfo.data.detail.minannualincm;
    const maxannualincm = orderInfo.data.detail.maxannualincm;
    let annualIncome = '';
    if (minannualincm && maxannualincm) {
        annualIncome = minannualincm + '万円～' + maxannualincm + '万円';
    } else if (minannualincm && !maxannualincm) {
        annualIncome = minannualincm + '万円～';
    } else if (!minannualincm && maxannualincm) {
        annualIncome = '～' + maxannualincm + '万円';
    }
    detail.annualIncome = annualIncome;

    let loocation = '';
    // 勤務地(都道府県 市区町村)
    if (!isBooster) {
      const locationInfo = await fetchLocation({
        orderIds: [parseInt(orderId)],
        locationNo: '1'
      });
      if (locationInfo.data.detail) {
        const firstLocation = locationInfo.data.detail[0];
        if(firstLocation)
        {
          const prefName = await getMstNameByIdService(firstLocation.prefId, storeBase.MST_PREF, store);
          const cityName = await getMstNameByIdService(firstLocation.cityId, storeBase.MST_CITY, store);
          loocation = (prefName ?? '') + (cityName ?? '') + (firstLocation.addr ?? '');
        }
      }
    } else {
      const locationInfo = await fetchLocationMt({
        orderIds: [orderId],
        locationNo: '1'
      });
      if (locationInfo.data.detail) {
        const firstLocation = locationInfo.data.detail[0];
        if(firstLocation)
        {
          loocation = firstLocation.addr ?? '';
        }
      }
    }
    detail.location = loocation;

    // 仕事内容
      detail.jobDescription = orderInfo.data.detail.wkcontents;
      detail.necessaryexp = orderInfo.data.detail.necessaryexp;
      if (!isBooster) {
        detail.languageSkill = getHtmlLangueSkill(orderInfo.data.detail.languageskill);
        let wkcontentsUpdRange = '雇い入れ直後：仕事内容に記載の業務　　変更の範囲：会社の定める業務（詳細は面接時にご確認ください）';
        if(orderInfo.data.detail.wkcontentsUpdRange)
        {
            wkcontentsUpdRange = '雇い入れ直後：仕事内容に記載の業務　　変更の範囲：' + orderInfo.data.detail.wkcontentsUpdRange + ' （詳細は面接時にご確認ください）';
        }
        detail.wkcontentsUpdRange = wkcontentsUpdRange;

        detail.orderReasonMemo = orderInfo.data.detail.orderreasonmemo;
      }

      if(orderInfo.data.detail.recruitnum)
      {
        detail.employeenNum = orderInfo.data.detail.recruitnum;
      }
      detail.emptype = orderInfo.data.detail.emptypeId2;
      if (!isBooster) {
        detail.lstschl = orderInfo.data.detail.schlId2;
        //雇用期間
        detail.employmentPeriod = formatEmploymentPeriodAndContract(orderInfo.data.detail);
        detail.employmentPeriodUpdTiming = orderInfo.data.detail.employmentPeriodUpdTiming;
      }
      if (!isBooster) {
        detail.income = orderInfo.data.detail.income2;
      } else {
        detail.income = orderInfo.data.detail.annualincmmemo;
      }
      detail.allowance = orderInfo.data.detail.allowanceId2;
      detail.insurance = orderInfo.data.detail.insuranceId2;
      if (!isBooster) {
        detail.annualincmMemo = orderInfo.data.detail.annualincmmemo;
        detail.memo1 = orderInfo.data.detail.allowance2;
      }
      // 就業時間
      if (isBooster) {
         detail.wkhours = orderInfo.data.detail.wkhours;
      } else {
         detail.wkhours = await formatEmploymentTimeDetails(orderInfo.data.detail);
      }
      detail.holidays = orderInfo.data.detail.holidayvacationId2;
      detail.allowances = orderInfo.data.detail.programId2;
      if (!isBooster) {
        let incm_type = orderInfo.data.detail.incmtypeId2;		
        if (incm_type && orderInfo.data.detail.incentiveFlg2) {
          incm_type += '<br/>' + orderInfo.data.detail.incentiveFlg2;
        }
        detail.incmtype = incm_type;

        if(orderInfo.data.detail.holidays && orderInfo.data.detail.holidays2)
        {
          detail.holidaycodicil = orderInfo.data.detail.holidays + '<br/>' + orderInfo.data.detail.holidays2;
        }
        else
        {
          
          detail.holidaycodicil = (orderInfo.data.detail.holidays??'') + (orderInfo.data.detail.holidays2??'');
        }

        if(orderInfo.data.detail.transferFlg2 && orderInfo.data.detail.transfermemo)
        {
            detail.transfer = orderInfo.data.detail.transferFlg2 + '<br/>' + orderInfo.data.detail.transfermemo;
        }
        else
        {
          detail.transfer = (orderInfo.data.detail.transferFlg2??'') + (orderInfo.data.detail.transfermemo??'');
        }

        if(orderInfo.data.detail.possibleovertimeId)
        {
          detail.possibleovertime = await getMstNameByIdService(orderInfo.data.detail.possibleovertimeId, storeBase.MST_OVERTIME, store);
        }	 

        detail.interviewmemo = orderInfo.data.detail.interviewmemo;
        detail.selectionId = orderInfo.data.detail.selectionId;
        detail.selectionLocationName = orderInfo.data.detail.selectionLocationname;
        detail.selectionOthercontent = orderInfo.data.detail.selectionOthercontent;
      }

      // Client info
      if(orderInfo.data.detail.clientId)
      {
        let clientState;
        if (isBooster) {
          clientState = await fetchTrnClientMtById(orderInfo.data.detail.clientId);
        } else {
          clientState = await fetchTrnClientById(orderInfo.data.detail.clientId);
        }
        if(clientState.data.detail)
        {
          const clientInfo = clientState.data.detail;
           if(clientInfo.representativepost && !isBooster)
           {
              detail.representative = clientInfo.representativepost + ' ' + clientInfo.representativename;
           }
           else
           {
              detail.representative = clientInfo.representativename;
           }

          detail.capital = clientInfo.capital;           
          detail.clienturl = clientInfo.clienturl;
          detail.busicontents = clientInfo.busicontents;
          if (!isBooster) {
            detail.indsctg = clientInfo.officememo;
            detail.resume = getResume(clientInfo);
            detail.planresult = await getPlanResult(clientInfo);
            if(clientInfo.marketId)
            {
              const maketState = await fetchMarketName(clientInfo.marketId);
              if(maketState.data.detail)
              {
                detail.marketid = maketState.data.detail;
              }
            }

            let frigncptl_text = '国内系';
            if (clientInfo.frigncptlFlg == 1)
            {
              frigncptl_text = '外資系';
            }
            detail.frigncptlflg = frigncptl_text;
            detail.compfeature = clientInfo.compfeature;
            detail.compstyle = clientInfo.compstyle;
            detail.workLocation = await getWorkLocation(orderInfo.data.detail, clientInfo, store);
            detail.remotework = await getRemoteWork(orderInfo.data.detail, clientInfo, store);
            detail.sidebusiness = await getSideBusiness(orderInfo.data.detail, clientInfo, store);
            detail.passivesmoking = await getPassiveSmoking(orderInfo.data.detail, clientInfo);
          } else {
            detail.workLocation = await getWorkLocationMt(orderInfo.data.detail.orderId);
          }
        }
      }

      
      detail.approvedStatusId = orderInfo.data.detail.approvedstatusId;
      detail.trnShintyokuWithCareer = orderInfo.data.detail.trnShintyokuWithCareer;
      if(orderInfo.data.detail.trnShintyokuWithCareer && orderInfo.data.detail.trnShintyokuWithCareer.length > 0)
      {
          let introduceDate = orderInfo.data.detail.trnShintyokuWithCareer[0].introduceDate;
          if (introduceDate && introduceDate.includes(' ')) {
            introduceDate = introduceDate.split(' ')[0];
          }    
          detail.introductionDate = introduceDate;
      }
      detail.entryFormUrl = orderInfo.data.detail.entryFormUrl;
  }
  return detail;
};

/**
 * Formats employment period and contract renewal information.
 * @param data - Object containing employment period and contract renewal properties.
 * @returns A formatted string with employment period and contract renewal details.
 */
const formatEmploymentPeriodAndContract  = (data: any) => {
  let contract = '';
  // If contract update flag is 1 (renewal limit exists)
  if (data.contractUpdFlg === 1) {
    contract = '<br/>更新上限あり　' + data.contractUpdLimit + '　' + data.contractUpdStd;
  }
  // If contract update flag is 2 (no renewal limit)
  if (data.contractUpdFlg === 2) {
    contract = '<br/>更新上限なし';
  }
  return (data.employmentPeriod2??'') + contract;
};

/**
 * Generates a formatted string describing the employment time details.
 * @param trnorder - Object trnorder.
 * @returns A formatted string with employment time information.
 */
const formatEmploymentTimeDetails  = async (trnorder: any) => {
  const outputs = trnorder.wkhours.split('///');
  outputs.push(trnorder.overtimeFlg2);
  outputs.push(trnorder.flextimeId2);
  let worktypeName = '';
  if(trnorder.worktypeId)
  {
    const workTypeState = await fetchWorkType(trnorder.worktypeId);
    if(workTypeState.data.detail && workTypeState.data.detail.worktypename)
    {
      worktypeName = '労働時間:' + workTypeState.data.detail.worktypename;
    }
  }
  outputs.unshift(worktypeName);
  return outputs.join('<br/>');

};

export const getJobSearchPublicService = async (params: TrnOrderJobSearchPublicRequest) => {
  return await getJobSearchPublicList(params);
};

export const getOrderInfoService = async (orderId: string, isBrowsing = false, isNeedCheckValidate = false, isPublic= false, isBooster = false, store: any) : Promise<JobDetail>  => {
  return await fetchOrderInfoByOrderId(orderId, isBrowsing, isNeedCheckValidate, isPublic, isBooster, store);
};

export const getTrnShintyokuInfoService = async (orderId: number)  => {
  return await fetchTrnShintyokuInfo(orderId);
};

